import { getMediaqueryScreen } from './getMediaQueryScreen.ts';

// `document` fires a `breakpointchange` event when the CSS breakpoint defined

// by tailwind changes.
(() => {
  function fireEvent() {
    console.log('Breakpoint changed to:', getMediaqueryScreen());
    document.dispatchEvent(
      new CustomEvent('breakpointchange', {
        detail: { screen: getMediaqueryScreen() },
      })
    );

    setTimeout(() => {
      // This is a workaround to ensure that the event is fired after the
      // transition ends, allowing any dependent scripts to react to the change.
      document.dispatchEvent(
        new CustomEvent('breakpointchange', {
          detail: { screen: getMediaqueryScreen() },
        })
      );
    }, 200);
  }

  document.addEventListener('DOMContentLoaded', () => {
    console.log('Mediaquery script loaded');
    const mediaquery = document.getElementById('mediaquery');

    if (mediaquery) {
      fireEvent();
      mediaquery.addEventListener('transitionend', fireEvent);
    }
  });
})();
